import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { Grid, Row, Col, Tabs, Tab, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

import SummaryTable from '../components/SummaryTable';
import IssuesPopover from '../components/IssuesPopover';
import StageInventoryPopover from '../components/StageInventoryPopover';

import '../css/dependencies.css';

class Summary extends Component {

    assetTypes     = {};
    stageInventory = {};
    issues         = {};

    stageInventoryTable = React.createRef();

    issuesRenderer(instance, td, row, col, prop, value, cellProperties) {
        if (instance.getDataAtCell(row, col) == 0) {
            ReactDOM.render( <p style={{ color: '#707070', margin: '0' }}>{value}</p> , td);
            return td;
        }

        const issue = instance.getDataAtCell(row, 0);

        const popover = (
            <IssuesPopover
                issue={issue}
                severity={this.issues[issue].severity}
                jobs={this.issues[issue].jobs}
            >
            </IssuesPopover>
        );

        const overlayTrigger = (
            <OverlayTrigger trigger="click" placement="left" overlay={popover} rootClose>
                <div><a className='issues-link' href='#'>{value}</a></div>
            </OverlayTrigger>
        );

        ReactDOM.render(overlayTrigger, td);

        return td;
    }

    stageInventoryRenderer(instance, td, row, col, prop, value, cellProperties) {
        const archive = instance.getDataAtCell(row, 0);
        const engine = instance.getDataAtCell(row, 1);
        const project = instance.getDataAtCell(row, 2);
        const stageType = instance.getDataAtCell(row, 3);
        const key = `${archive}/${engine}/${project}/${stageType}`;

        const popover = (
            <StageInventoryPopover
                stageType={this.stageInventory[key]}
            />
        );

        const overlayTrigger = (
            <OverlayTrigger trigger="click" placement="left" overlay={popover} rootClose>
                <div><a className='stageInventory-link' href='#'>{value}</a></div>
            </OverlayTrigger>
        );

        ReactDOM.render(overlayTrigger, td);

        return td;
    }

    // This is only here because it fixes an issue where the issues table's
    // sorting resets when the count is clicked on (rerender...)
    // Not sure what the cause or how to properly fix
    shouldComponentUpdate(nextProps){
        return false;
    }

    downloadStageInventory(uploadName) {
        const data = this.stageInventoryTable.current.props.data;

        let csv = "Archive, Engine, Project, Stage Type, Count\n"
        + data.map(function(d) {
            return `${d.archive},${d.engine},${d.project},${d.stageType},${d.count}`;
        }).join('\n');

        let fileName = `${uploadName}.stage-inventory.csv`;
       	let blob = new Blob([ csv ], {
            type : "application/csv;charset=utf-8;"
        });

        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(blob, fileName);
        } else {
            let link = document.createElement("a");
            let csvUrl = URL.createObjectURL(blob);
            link.href = csvUrl;
            link.style = "visibility:hidden";
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
		}
    }

    render() {
        this.assetTypes     = {};
        this.stageInventory = {};
        this.issues         = {};

        for (let assetName in this.props.data) {
            const asset = this.props.data[assetName];

            // Count asset types
            if(!this.assetTypes[asset.assetType]) {
                this.assetTypes[asset.assetType] = { assetType : asset.assetType, count: 0 };
            }
            this.assetTypes[asset.assetType].count++;

            // Count stage types
            if ("stageTypeInventory" in asset) {

                for (let stageType of asset.stageTypeInventory) {
                    let key = `${asset.archive}/${asset.engine}/${asset.project}/${stageType.stageType}`;

                    if (!(key in this.stageInventory)) {
                        this.stageInventory[key] = {
                            archive: asset.archive,
                            engine: asset.engine,
                            project: asset.project,
                            stageType: stageType.stageType,
                            count: 0,
                            jobs: []
                        };
                    }

                    this.stageInventory[key].count += stageType.count;
                    this.stageInventory[key].jobs.push({
                        archive: asset.archive,
                        engine: asset.engine,
                        project: asset.project,
                        job: asset.asset,
                        count: stageType.count
                    });
                }
            }

            // Count compliance issues
            if ("complianceBlocker" in asset) {
                for (let test of asset.complianceBlocker) {
                    if (!(test.rule in this.issues)) {
                        this.issues[test.rule] = {
                            issue: test.rule,
                            severity: "Blocker",
                            jobs: []
                        };
                    }
                    if (test.result === "FAILURE" || test.result === "ERROR") {
                        this.issues[test.rule].jobs.push({
                            archive: asset.archive,
                            engine: asset.engine,
                            project: asset.project,
                            job: asset.asset,
                            message: test.message || ""
                        });
                    }
				}
            }
            if ("complianceWarning" in asset) {
                for (let test of asset.complianceWarning) {
                    if (!(test.rule in this.issues)) {
                        this.issues[test.rule] = {
                            issue: test.rule,
                            severity: "Warning",
                            jobs: []
                        };
                    }
                    if (test.result === "FAILURE" || test.result === "ERROR") {
                        this.issues[test.rule].jobs.push({
                            archive: asset.archive,
                            engine: asset.engine,
                            project: asset.project,
                            job: asset.asset,
                            message: test.message || ""
                        });
                    }
				}
			}
       	}

        return (
            <Tabs defaultActiveKey="assetTypes" id="summary-tabs">

                <Tab eventKey="assetTypes" title="Asset Types">
                    <Grid>
                        <Row className="show-grid" >
                            <Col xs={12} md={12}>
                                <br />
                                <SummaryTable
                                    id="assetTypesTable"
                                    data={
                                        Object.keys(this.assetTypes).map(assetType => this.assetTypes[assetType])
                                    }
                                    headers={["Asset Type", "Count"]}
                                />
                            </Col>
                        </Row>
                    </Grid>
                </Tab>

                <Tab eventKey="stageInventory" title="Stage Inventory">
                    <Grid>
                        <Row className="show-grid" >
                            <Col xs={11} md={11}/>
                            <Col xs={1} md={1}>			
                                <Button className="btn-download" onClick={() => { this.downloadStageInventory(this.props.fileName) }}>
                                    <OverlayTrigger placement="left" overlay={<Tooltip id="edit">Download Table</Tooltip>}>
                                        <i className="fa fa-download"></i>
                                    </OverlayTrigger>
                                </Button>
                            </Col>
                        </Row>
                        <Row className="show-grid" >
                            <Col xs={12} md={12}>
                                { this.props.stageInventoryNotAvailable ?
                                    <p style={{ textAlign: 'center'  }}>Resubmit your upload to view stage inventory</p>
                                    :
                                    <SummaryTable
                                        id="stageInventoryTable"
                                        ref={this.stageInventoryTable}
                                        data={
                                            Object.keys(this.stageInventory).map(key => {
                                                return {
                                                    "archive": this.stageInventory[key].archive,
                                                    "engine": this.stageInventory[key].engine,
                                                    "project": this.stageInventory[key].project,
                                                    "stageType": this.stageInventory[key].stageType,
                                                    "count": this.stageInventory[key].count
                                                };
                                            })
                                        }
                                        headers={["Archive", "Engine", "Project", "Stage Type", "Count"]}
                                        cellRenderer={(row, col) => {
                                            let cellProperties = {};
                                            if (col === 4) {
                                                cellProperties.renderer = this.stageInventoryRenderer.bind(this)
                                            }

                                            return cellProperties;
                                        }}
                                    />
                                }
                            </Col>
                        </Row>
                    </Grid>
                </Tab>

                <Tab eventKey="issues" title="Issues">
                    <Grid>
                        <Row className="show-grid" >
                            <Col xs={12} md={12}>
                                <br />
                                { this.props.complianceNotAvailable ?
                                    <p style={{ textAlign: 'center' }}>Resubmit your upload to view compliance issues</p>
                                    :
                                    <SummaryTable
                                        id="issuesTable"
                                        data={
                                            Object.keys(this.issues).map(issue => {
                                                return { "issue": issue, "count": this.issues[issue].jobs.length }
                                            })
                                        }
                                        headers={["Compliance Issue", "Job Count"]}
                                        cellRenderer={(row, col) => {
                                            let cellProperties = {};
                                            if (col === 1) {
                                                cellProperties.renderer = this.issuesRenderer.bind(this)
                                            }

                                            return cellProperties;
                                        }}
                                    />
                                }
                            </Col>
                        </Row>
                    </Grid>
                </Tab>

            </Tabs>
        );
    }
}

export default Summary;
